import React from 'react';
import { Box, Flex, Icon, Text, useColorModeValue } from '@chakra-ui/react';
import { MdEvent, MdCancel, MdWarning, MdPersonAdd, MdEmojiEvents, MdHealthAndSafety } from 'react-icons/md';

const ICONS = {
  appointment_soon: MdEvent,
  booking_created: MdPersonAdd,
  booking_cancelled: MdCancel,
  no_show: MdWarning,
  lead_completed: MdEmojiEvents,
  sanitary_book_overdue: MdHealthAndSafety,
  sanitary_book_due_soon: MdHealthAndSafety,
};

export function NotificationMenuItem({ item, onNavigate }) {
  const textColor = useColorModeValue('navy.700', 'white');
  const muted = useColorModeValue('gray.500', 'gray.400');
  const hoverBg = useColorModeValue('gray.50', 'whiteAlpha.100');
  const IconComp = ICONS[item.type] || MdEvent;

  return (
    <Flex
      align="flex-start"
      gap={3}
      py={2}
      px={1}
      cursor={item.link ? 'pointer' : 'default'}
      borderRadius="md"
      _hover={item.link ? { bg: hoverBg } : undefined}
      onClick={() => item.link && onNavigate?.(item.link)}
    >
      <Flex
        w="40px"
        h="40px"
        borderRadius="12px"
        bg={
          item.type === 'lead_completed'
            ? 'green.500'
            : item.type === 'sanitary_book_overdue'
              ? 'red.500'
              : item.type === 'sanitary_book_due_soon'
                ? 'orange.400'
                : 'brand.500'
        }
        color="white"
        align="center"
        justify="center"
        flexShrink={0}
      >
        <Icon as={IconComp} boxSize={5} />
      </Flex>
      <Box flex="1" minW={0}>
        <Text fontSize="sm" fontWeight="700" color={textColor} lineHeight="short">
          {item.title}
        </Text>
        <Text fontSize="sm" color={muted} noOfLines={2}>
          {item.message}
        </Text>
      </Box>
    </Flex>
  );
}
